import { PaymentType } from "../../../../../../../../Wrap/Constants/Enums/Apply/PaymentType";
import { DisinvestmentStrategyType } from "../../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { BeneficiaryRelationship } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryRelationship";
import { BeneficiaryType } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryType";
import { TransferType } from "../../../../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { PaymentPayer } from "../../../../../../../../Wrap/Constants/Enums/Payments/PaymentPayer";
import { EscalationBasis } from "../../../../../../../../Wrap/Constants/Enums/RegularWithdrawal/EscalationBasis";
import { TransferStatus } from "../../../../../../../../Wrap/Constants/Enums/Transfer/TransferStatus";
import { IndexationType } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";

export const DisinvestmentTipMsg =
    "Editing Auto-disinvestment strategy here, will apply these changes at account level.";

export const PaymentPayerMapper = {
    [PaymentPayer.NotSpecified]: "Not Specified",
    [PaymentPayer.Client]: "Client",
    [PaymentPayer.ThirdParty]: "Third Party",
    [PaymentPayer.Employer]: "Employer",
    [PaymentPayer.EmployerSalaryDeduction]: "Salary Deduction",
};

export const PaymentTypeMapper = {
    [PaymentType.Single]: "Single",
    [PaymentType.Regular]: "Regular",
};

export const TransferStatusMapper = {
    [TransferStatus.NotSpecified]: "Not Specified",
    [TransferStatus.Pending]: "Pending",
    [TransferStatus.Completed]: "Completed",
};

export const TransferTypeMapper = {
    [TransferType.NotSpecified]: "Not Specified",
    [TransferType.Cash]: "Cash",
    [TransferType.InSpecie]: "In Specie",
    [TransferType.Mixed]: "Mixed",
};

export const DisinvestmentStrategyTypeMap = {
    [DisinvestmentStrategyType.LVS]: "Least Volatile Stock (LVS)",
    [DisinvestmentStrategyType.Lifo]: "Last In, First Out (LiFo)",
    [DisinvestmentStrategyType.Proportional]: "Proportional",
};

export const EscalationBasisMap = {
    [EscalationBasis.RetailPriceIndex]: "RetailPriceIndex",
    [EscalationBasis.Fixed]: "User defined percentage",
    [EscalationBasis.AverageWeeklyEarnings]: "Average weekly earnings",
};

export const RelationshipTypeArraysMaps = {
    [BeneficiaryRelationship.NotSpecified]: "Not specified",
    [BeneficiaryRelationship.Brother]: "Brother",
    [BeneficiaryRelationship.Charity]: "Charity",
    [BeneficiaryRelationship.Child]: "Child",
    [BeneficiaryRelationship.ChildInLaw]: "ChildInLaw",
    [BeneficiaryRelationship.CivilPartner]: "CivilPartner",
    [BeneficiaryRelationship.CivilUnion]: "CivilUnion",
    [BeneficiaryRelationship.Cohabitant]: "Cohabitant",
    [BeneficiaryRelationship.Daughter]: "Daughter",
    [BeneficiaryRelationship.Dependant]: "Dependant",
    [BeneficiaryRelationship.FinancialDependant]: "FinancialDependant",
    [BeneficiaryRelationship.Friend]: "Friend",
    [BeneficiaryRelationship.Grandchild]: "Grandchild",
    [BeneficiaryRelationship.LegalGuardian]: "LegalGuardian",
    [BeneficiaryRelationship.Other]: "Other",
    [BeneficiaryRelationship.Owner]: "Owner",
    [BeneficiaryRelationship.Parent]: "Parent",
    [BeneficiaryRelationship.Partner]: "Partner",
    [BeneficiaryRelationship.PartnerSpouse]: "PartnerSpouse",
    [BeneficiaryRelationship.Relative]: "Relative",
    [BeneficiaryRelationship.Sibling]: "Sibling",
    [BeneficiaryRelationship.Sister]: "Sister",
    [BeneficiaryRelationship.Son]: "Son",
    [BeneficiaryRelationship.Spouse]: "Spouse",
    [BeneficiaryRelationship.Trust]: "Trust",
};

export const BeneficiaryTypeArraysMaps = {
    [BeneficiaryType.Beneficiary]: "Beneficiary",
    [BeneficiaryType.Charity]: "Charity",
    [BeneficiaryType.Individual]: "Individual",
    [BeneficiaryType.Nominee]: "Nominee",
    [BeneficiaryType.Organisation]: "Organisation",
    [BeneficiaryType.Other]: "Other",
    [BeneficiaryType.Partner]: "Partner",
    [BeneficiaryType.Trustee]: "Trust",
};

export const BeneficiaryTypeArray = [BeneficiaryType.Individual, BeneficiaryType.Charity, BeneficiaryType.Trustee];

export const BeneficiaryTooltipMessage= "This is a summary of the primary beneficiaries who have been nominated by the scheme member. Where an Aberdeen SIPP Death Benefits Nomination form or other scheme member instruction has been received by us, we will use this form or instruction alongside the information shown here to decide who should receive death benefits from the Aberdeen SIPP."

export const BeneficiaryLightboxpMessage1= "If a charity is being nominated, please include the registered charity number alongside the name of the charity."

export const BeneficiaryLightboxpMessage2= "If you are updating existing primary beneficiaries online, please review any associated Death Benefit Nomination form saved in the document library to check if these instructions also need to be revised to reflect your client’s current wishes."

export const BeneficiaryProportionWarningMessage= "The total proportion must be 100%"

export const NoBeneficiariesWarningMessage= "No beneficiaries are currently set up. Add new beneficiary or cancel to exit"

export const DrawdownPriceLockConfirmationMessage=
{
    paragraph1: "By selecting 'yes' you are confirming you have read and understood the Drawdown Price Lock guide available on the Literature library, and authorise us to make the relevant changes.",
    paragraph2: "To get the most out of the Drawdown Price Lock, your client's total platform eligible assets should be at their maximum on the platform prior to the lock being applied.",
    paragraph3: "For example, this would mean the lock is applied:",
    list1: "After all transfers have completed;",
    list2: "After all fund investments have completed;",
    list3: "Prior to any tax-free lump sum or income being paid;",
    list4: "Prior to any adviser charging being paid; and",
    list5bold: "Please note: ",
    list5: "the Drawdown Price Lock cannot be applied to Aberdeen JSIPP accounts.",
    footer1: "This is to ensure your client locks in at the lowest possible platform charge.",
    footer2: "If you want to apply family linking prior to the price lock, please call 0345 279 1001 before completing the wizard.",
}
